export default __webpack_public_path__ + "static/media/13.f127d0f5.png";